@if ($model() != null) {
    <div class="wrapper px-1" [class.single]="$model().stateId == FlowObjectInstanceState.Finished || !$isPollingFinished()">
        @if ($model().stateId == FlowObjectInstanceState.Finished && $hasErrors() && $configSchema().taskOutboundApi.ignoreErrors) {
            <!-- Task info: falha na comunicação com ignoreErrors -->
            <div class="message-container">
                <div class="message-row">
                    <i class="fas fa-exclamation-circle warning mr-3"></i>
                    <span class="headline">
                        Falha na comunicação com o sistema
                        <span class="d-inline-block text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                    </span>
                    <i class="fas fa-exclamation-circle warning ml-3"></i>
                </div>

                <hr />

                <div class="message-row">
                    <span>
                        Houve falha na comunicação com o sistema
                        <span class="d-inline-block text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>,
                        mas esta Tarefa foi configurada pelos administradores para ignorar eventuais erros de comunicação com
                        o sistema de destino
                    </span>
                </div>
            </div>
        } @else {
            @if ($model().stateId == FlowObjectInstanceState.Finished) {
                <!-- Task info: finalizado com sucesso -->
                <div class="message-container">
                    <div class="message-row">
                        <i class="fas fa-check-circle success mr-3"></i>
                        <span class="headline">
                            Comunicação com o sistema
                            <span class="text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                            realizada com sucesso
                        </span>
                        <i class="fas fa-check-circle success ml-3"></i>
                    </div>
                </div>
            } @else {
                @if (!$isPollingFinished()) {
                    <!-- Task info: polling em curso -->
                    <div class="message-container py-2">
                        <div class="message-row mt-2">
                            <i class="fas fa-sync fa-spin await mr-3"></i>
                            <span class="headline">
                                Aguardando comunicação com o sistema
                                <span class="d-inline-block text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                            </span>
                            <i class="fas fa-sync fa-spin await ml-3"></i>
                        </div>

                        <div class="message-row mt-4">
                            <div class="bar-container">
                                <div class="progress-bar" [style.width.%]="$pollingProgress()">
                                    <span class="text">Carregando...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                } @else {
                    <!-- Task info: falha na comunicação sem ignoreErrors -->
                    <div class="message-container">
                        <div class="message-row mt-2">
                            <i class="fas fa-minus-circle error mr-3"></i>
                            <span class="headline">
                                Erro na comunicação com o sistema
                                <span class="d-inline-block text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                            </span>
                            <i class="fas fa-minus-circle error ml-3"></i>
                        </div>

                        @if (Utils.isNotNullOrEmpty($message())) {
                            @if (isMessageFromApi) {
                                <div class="message-row">
                                    <p>Mensagem retornada pelo sistema:</p>
                                </div>
                            }

                            <div class="message-row" [class.mt-4]="!isMessageFromApi">
                                <span class="document-highlight info-font">{{$message()}}</span>
                            </div>
                        }
                    </div>
                }
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
